import { API_DOMAINS } from '@/constants';

export interface PaywallConfig {
	trialAvailable: boolean;
	country?: string;
}

interface GetPaywallConfigArgs {
	uuid: string;
	signal?: AbortSignal;
}

export const PaywallConfigApiService = {
	async getPaywallConfig({
		uuid,
		signal,
	}: GetPaywallConfigArgs): Promise<PaywallConfig | null> {
		const response = await fetch(API_DOMAINS.GET_PAYWALL_CONFIG, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ uuid }),
			signal,
			cache: 'no-store',
		});
		if (!response.ok) return null;

		const data = (await response.json()) as Partial<PaywallConfig> | null;
		if (typeof data?.trialAvailable !== 'boolean') return null;

		return data as PaywallConfig;
	},
};
